var render, staticRenderFns
import script from "./StarPartial.vue?vue&type=script&lang=js&"
export * from "./StarPartial.vue?vue&type=script&lang=js&"
import style0 from "./StarPartial.vue?vue&type=style&index=0&id=520e57f5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520e57f5",
  null
  
)

export default component.exports